import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import InboundDashboard from './inbound/views/InboundDashboard';
import OutboundDashboard from './outbound/views/OutboundDashboard';

/**
 * Main routing component for the Truck Scheduler application
 * Handles both inbound and outbound truck scheduling routes
 * Updated to use the new modular structure with separate inbound and outbound directories
 */
const TruckSchedulerRoutes = ({ mode = 'inbound' }) => {
  const location = useLocation();
  const isInbound = mode === 'inbound';
  
  // Log the current path but don't store or redirect
  React.useEffect(() => {
    if (location.pathname) {
      console.log('TruckScheduler: Current path:', location.pathname);
      console.log('TruckScheduler: Using mode:', mode);
      console.log('TruckScheduler: Redirect mechanisms disabled - path will not be stored');
    }
  }, [location, mode]);
  
  return (
    <Routes>
      {/* Root route - no redirect, just render the dashboard directly */}
      <Route 
        path="/" 
        element={isInbound ? <InboundDashboard initialView="calendar" /> : <OutboundDashboard initialView="calendar" />}
      />
      
      {/* Inbound routes */}
      {isInbound && (
        <>
          <Route path="calendar" element={<InboundDashboard initialView="calendar" />} />
          <Route path="receiving" element={<InboundDashboard initialView="receiving" />} />
          <Route path="history" element={<InboundDashboard initialView="history" />} />
          {/* Removed catch-all redirect, component will render its default view instead */}
          <Route path="*" element={<InboundDashboard initialView="calendar" />} />
        </>
      )}
      
      {/* Outbound routes */}
      {!isInbound && (
        <>
          <Route path="calendar" element={<OutboundDashboard initialView="calendar" />} />
          <Route path="shipping" element={<OutboundDashboard initialView="shipping" />} />
          <Route path="history" element={<OutboundDashboard initialView="history" />} />
          <Route path="dashboard" element={<OutboundDashboard initialView="calendar" />} />
          {/* Removed catch-all redirect, component will render its default view instead */}
          <Route path="*" element={<OutboundDashboard initialView="calendar" />} />
        </>
      )}
    </Routes>
  );
};

// Export specific route components for direct use
export const InboundTruckRoutes = () => <TruckSchedulerRoutes mode="inbound" />;
export const OutboundTruckRoutes = () => <TruckSchedulerRoutes mode="outbound" />;

export default TruckSchedulerRoutes;